import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListFinancePartners from "../Components/Finance Partners/listFinancePartners";
import ViewFinancePartners from "../Components/Finance Partners/viewFinancePartners";
import AddFinancePartners from "../Components/Finance Partners/addFinancePartners";
import EditFinancePartners from "../Components/Finance Partners/editFinancePartners";


const FinancePartnersRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route
        path="/finance_partners"
        element={<ListFinancePartners></ListFinancePartners>}
      ></Route>
      <Route
        path="/finance_partners/view/:id"
        element={<ViewFinancePartners></ViewFinancePartners>}
      ></Route>
      <Route
        path="/finance_partners/add"
        element={canAdd ? <AddFinancePartners></AddFinancePartners> : <Navigate to="/finance_partners" replace />}
      ></Route>
      <Route
        path="/finance_partners/edit/:id"
        element={<EditFinancePartners></EditFinancePartners>}
      ></Route>
    </Routes>
  );
};

export default FinancePartnersRoutes;
